import * as React from 'react';

export function useUtilsService() {
  const isNotEmpty = React.useCallback((value) => {
    return !!value?.trim?.() ?? false;
  }, []);

  const formatJson = React.useCallback(
    (list) => list.reduce((obj, item) => ({ ...obj, ...item }), {}),
    [],
  );

  return {
    isNotEmpty,
    formatJson,
  };
}
